module.exports = __webpack_public_path__ + "static/img/build1.8dbd67e5.png";